export default __webpack_public_path__ + "static/media/261.43d5ef4d.png";